import { render, staticRenderFns } from "./edit-course.vue?vue&type=template&id=1fa46c72&scoped=true&"
import script from "./edit-course.vue?vue&type=script&lang=js&"
export * from "./edit-course.vue?vue&type=script&lang=js&"
import style0 from "./edit-course.vue?vue&type=style&index=0&id=1fa46c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa46c72",
  null
  
)

export default component.exports